
import { formattingNumber } from './../utils'

export const dataExportFields = ({ teamHash = {} }) => [
    {
        title: '类别',
        key: 'type',
        align:'center',
        minWidth: 200,
        fixed:'left',
    },
    {
        title: '项目组',
        key: 'project',
        align:'center',
        minWidth: 150,
        fixed:'left',
        render(h, { row }) {
            return <span>{ teamHash[row.project] ? teamHash[row.project].name : (row.project || '其他') }</span>
        }
    },
    {
        title: '收/退款',
        key: 'gatherRefund',
        align:'center',
        minWidth: 100,
        fixed:'left',
    },
    {
        title: '总计',
        key: 'sum',
        align:'right',
        minWidth: 120,
        fixed:'left',
        render(h, { row }) {
            return <span>{ isNaN(row.sum) ? (row.sum || '-') : formattingNumber(row.sum, 1) }</span>
        }
    }
]

export const typeHash = {
    course:'课程',
    member: '会员',
    other: '其他'
}